import React from 'react'
import PropTypes from 'prop-types'

import { digObject } from '@domain-group/javascript-utils'

import { Box, Form, SectionDivider } from '@domain-group/suit-theme'

import daysOfTheWeek from '@functions/daysOfTheWeek'

const Deadline = (props) => {
  const { publicationForm, type } = props

  const {
    entityState: {
      deadlines,
    },
    handlers,
  } = publicationForm

  const deadlineGroup = digObject(deadlines, type, {})

  const { day, time, weeks_before } = deadlineGroup

  return (
    <Box flexDirection="column">
      <SectionDivider boxProps={{ marginY: 'large' }}>{type.toUpperCase()}</SectionDivider>

      <Form.Row>
        <Form.Field label="Occurs">
          <select name={`deadlines.${type}.weeks_before`} value={weeks_before} {...handlers}>
            <option value="">Please Select...</option>
            <option value="0">Same Week</option>
            <option value="1">Previous Week</option>
          </select>
        </Form.Field>

        <Form.Field label="Day" marginTop={['large', 0]}>
          <select name={`deadlines.${type}.day`} value={day} {...handlers}>
            <option value="">Please Select...</option>
            {daysOfTheWeek.map(dayObject => (
              <option key={dayObject.key} value={dayObject.value}>{dayObject.title}</option>
            ))}
          </select>
        </Form.Field>
      </Form.Row>

      <Form.Field label="Time" marginTop="large">
        <input name={`deadlines.${type}.time`} type="time" value={time} {...handlers} />
      </Form.Field>
    </Box>
  )
}

Deadline.propTypes = {
  publicationForm: PropTypes.shape({
    entityState: PropTypes.object.isRequired,
    handlers: PropTypes.object.isRequired,
  }).isRequired,
  type: PropTypes.oneOf(['artwork', 'booking', 'editorial', 'ofi']),
}

export default Deadline
